<template>
    <a
        :href="href || 'javascript:void(0);'"
        @click="onClick"
        :rel="rel"
        :target="target"
        :class="innerType"
        :style="anchorStyle"
        :title="title"
        v-from="fromType"
        class="anchor"
    >
        <slot></slot>
    </a>
</template>
<script>
const TYPE = {
    strong: 'strong',
    normal: 'normal',
    weak: 'weak',
    custom: 'custom'
};
export default {
    name: 'EsfAnchor',
    inject: ['SEO_SOURCE_TYPE'],
    props: {
        href: {
            default: '',
            type: String
        },
        target: {
            default: '_self',
            type: String
        },
        rel:{
            default: '',
            type: String
        },
        type: {
            default: TYPE.normal,
            type: String
        },
        anchorStyle: {
            default: () => {},
            type: Object
        },
        title: {
            default: '',
            type: String
        },
        from: {
            default: '',
            type: String
        }
    },
    computed: {
        innerType() {
            const type = TYPE[this.type];
            if (this.type === TYPE.custom) return 'anchor-custom';
            if (!this.href || this.href === 'javascript:void(0);') return 'anchor-none';
            if (type) return `anchor-${type}`;
            return 'anchor-normal';
        },
        fromType() {
            if (this.from) {
                return {
                    from: this.from
                };
            }
            return {};
        }
    },
    methods: {
        onClick() {
            this.$emit('onAnchorClick');
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../index.scss';

.anchor {
    @include SCRegular;
    text-decoration: none;

    &:-webkit-any-link:focus {
        outline-offset: 0;
    }
    &:-webkit-any-link:active {
        color: $ajkLTHeadlinesColor;
    }

    &-none {
        cursor: text;
        color: #0b0f12;
    }

    &-strong {
        cursor: text;
        color: #0e3bbd;

        &:hover {
            color: #0e3bbd;
            cursor: pointer;
            text-decoration: underline;
        }
    }

    &-normal {
        cursor: text;
        color: #0b0f12;
        text-decoration: underline;

        &:hover {
            color: #0e3bbd;
            cursor: pointer;
            text-decoration: underline;
        }
    }

    &-weak {
        cursor: text;
        color: #474b4e;

        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }
}
</style>
